import { render } from "./setupClaims.vue?vue&type=template&id=be99f6b4"
import script from "./setupClaims.vue?vue&type=script&lang=js"
export * from "./setupClaims.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__